var wellKnownSymbol = require('../internals/well-known-symbol');
var Iterators = require('../internals/iterators');

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/is-array-iterator-method.js
// module id = 1038
// module chunks = 0